import React from "react"
import Title from "./Title"
import { FaAngleDoubleRight } from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"
import { Link } from "gatsby"

// const query = graphql`
//   {
//     allStrapiJobs(sort: {fields: id, order: DESC}) {
//       nodes {
//         strapiId
//         company
//         date
//         position
//         desc {
//           id
//           name
//         }
//       }
//     }
//   }
// `

function Jobs() {
  // const data = useStaticQuery(query)
  // const {
  //   allStrapiJobs: { nodes: jobs },
  // } = data
  const jobs = [
    {
      "id": 4,
      "company": "Yogaya Inc",
      "position": " Software Developer Technical Lead",
      "date": "August 2020 - Present",
      "created_at": "2022-04-11T09:15:07.115Z",
      "updated_at": "2022-04-11T09:15:07.115Z",
      "desc": [
        {
          "id": 7,
          "name": "Build high performing and low latency single / hybrid cloud (AWS) infrastructures. Next generation DevOps continuous integration and deployment pipelines."
        },
        {
          "id": 8,
          "name": "Design and build serverless web and mobile applications from scratch"
        }
      ]
    },
    {
      "id": 3,
      "company": "Public Labs",
      "position": "Outreachy Intern",
      "date": "Dec 2021 - Mar 2022",
      "created_at": "2022-04-11T09:13:49.671Z",
      "updated_at": "2022-04-11T09:13:49.671Z",
      "desc": [
        {
          "id": 5,
          "name": "Rebuild Spectral Workbench capture and analysis interface. Build a modern version of the “capture” interface for collecting data from a smartphone camera, and reworking and integrating that new interface into the Rails app"
        },
        {
          "id": 6,
          "name": "Complete upgrades by adding all previous features back into the new system, as well as build on the new systems to add new features and abilities"
        }
      ]
    },
    {
      "id": 2,
      "company": "Microverse",
      "position": "Technical Support Engineer",
      "date": "October 2020 - November 2021",
      "created_at": "2022-04-11T09:10:12.482Z",
      "updated_at": "2022-04-11T09:10:12.482Z",
      "desc": [
        {
          "id": 3,
          "name": "Provide quality and timely feedback to students on their technical projects making them better software developers"
        },
        {
          "id": 4,
          "name": "Ensure conduct code that improves code organization and overall performance"
        }
      ]
    },
    {
      "id": 1,
      "company": "Kuva Africa",
      "position": "Tech Program Facilitator",
      "date": "May 2019 - March 2021",
      "created_at": "2022-04-11T09:08:39.097Z",
      "updated_at": "2022-04-11T09:08:39.097Z",
      "desc": [
        {
          "id": 1,
          "name": "Patiently trained 20+ girls, ages 9 - 18, SCRATCH programming language during summer camps."
        },
        {
          "id": 2,
          "name": "Building confidence, empathy, and career orientation in STEM through outreach programs that have impacted 100+ girls so far as more get into STEM."
        }
      ]
    },
 
    
    
  ]
  const [value, setValue] = React.useState(0)
  const { company, position, date, desc } = jobs[value]

  return <section className="section jobs">
    <Title title="experience" />
    <div className="jobs-center">
       <div className="btn-container">
         {jobs.map((item, index)=>{
           return (
            <button 
            key={item.strapiId}
            onClick={()=> setValue(index)}
            className={`job-btn ${index === value && 
            'active-btn'}`}
            >
              {item.company}
            </button>
           )
          })}
       </div>
       <article className="job-info">
        <h3>{position}</h3>
        <h4>{company}</h4>
        <p className="job-date">{date}</p>
        {
          desc.map((item)=>{
            return (
              <div key={item.id} className="job-desc">
                <FaAngleDoubleRight className="job-icon"></FaAngleDoubleRight>
                <p>{item.name}</p>
              </div>
            )
          })
        }
       </article>
    </div>
    <Link to="/about" className="btn center-btn">
      more info
    </Link>
  </section>
}

export default Jobs
